$(document).ready(function () {
	$('.expandable').on('click', function () {
		$(this).toggleClass('opened');
	})
});